import { Icon, Grid } from "@scuf/common";
import "../Diario/Progress-Diario.css";

export default function CaretIcon(body) {
  return (
    <>
      <Grid.Column
        className="percent-column"
        xsWidth="12"
        sWidth="2"
        mWidth="2"
        lWidth="2"
        xlWidth="3"
      >
        <p>{body.body.actual}%</p>
        <p>
          {parseFloat(body.body.actual) > parseFloat(body.body.previus) && (
            <Icon root="global" name="caret-up" color="green" size="medium" />
          )}

          {parseFloat(body.body.actual) < parseFloat(body.body.previus) && (
            <Icon root="global" name="caret-down" color="red" size="medium" />
          )}

          {parseFloat(body.body.actual) === parseFloat(body.body.previus) && (
            <Icon
              root="global"
              name="slider-controls-minus"
              color="yellow"
              size="medium"
            />
          )}
        </p>
      </Grid.Column>
    </>
  );
}
